import { Suspense } from 'react';
import React from 'react';
import AdministrationModule from './AdministrationModule';

const AdministrationModuleProxy = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <AdministrationModule />
  </Suspense>
);

export default AdministrationModuleProxy;